import $ from 'jquery';
import Glide from '@glidejs/glide';

export function LandingPage() {
  if (window.intervalIds) {
    window.intervalIds.forEach(clearInterval);
  }
  window.intervalIds = [];

  let isMobile = $(window).width() < 1280;
  let timeOut = !isMobile ? 500 : 0;

  // Hero animation
  if (!$('.mkt-landing__hero').hasClass('-animated')) {
    $('.mkt-landing__hero').addClass('-animated');
  }

  // Startup animations on Landing 2
  if ($('#circle-1').length > 0) {
    setTimeout(() => {
      setTimeout(() => {
        $('#circle-1').css({
          'fill-opacity': '1',
          'filter': 'unset',
        });
      }, 0);

      setTimeout(() => {
        $('#circle-2').css({
          'fill-opacity': '1',
          'filter': 'unset',
        });
      }, 100);

      setTimeout(() => {
        $('#circle-3').css({
          'fill-opacity': '1',
          'filter': 'unset',
        });
      }, 200);

      setTimeout(() => {
        $('#circle-4').css({
          'fill-opacity': '1',
          'filter': 'unset',
        });
      }, 300);

      setTimeout(() => {
        $('#circle-5').css({
          'fill-opacity': '1',
          'filter': 'unset',
        });
      }, 400);

      setTimeout(() => {
        $('#circle-6').css({
          'fill-opacity': '1',
          'filter': 'unset',
        });
      }, 500);

      setTimeout(() => {
        $('.main-page__hero').addClass('-stop-init-animation');
      }, 1000);
    }, timeOut);
  }

  // Checkbox validation on Landing 2
  if ($('form[data-type="with-external-checkbox"]').length > 0) {
    let $button = $('#mc-embedded-subscribe');
    let $checkbox = $('#agreement-checkbox');
    let $error = $('#agreement-error');

    $button.on('click', function(e) {
      if (!$checkbox.is(':checked')) {
        e.preventDefault();

        $error.show();
      } else {
        $error.hide();
      }
    });
  }

  // GlideJS (carousel in Latest Posts)
  if ($('.glide').length > 0) {
    let per_view = 1.165;
    let gap = 24;

    var resizeEvent = new Event('resize');
    window.dispatchEvent(resizeEvent);

    new Glide('.glide', {
      type: 'slider',
      focusAt: 0,
      startAt: 0,
      perView: per_view,
      gap: gap
    }).mount();

    // Open video in the Pixellu Presents section
    var $slider = $('.blog__presents__slider .glide');

    $('.blog__presents__slider__item__image').each(function () {

      $(this).on('click.pxtrigger', function () {

        var $target = $(this).parent().find('.video-target');

        if (!$slider.hasClass('glide--draggable') && $target.attr('draggable') === 'true')
          $target.magnificPopup('open');

      });

    });

  }

  // Change MailChimp default success message
  if (window.location.pathname.includes('/smartalbums/aiassistant')) {
    function checkAndReplaceMessage() {
      const successDiv = $('#mce-success-response');
      const successText = 'Success! Your AI Album Assistant is on its way. Check your email in the next 2-3 minutes.';

      if (successDiv && successDiv.text() !== '' && successDiv.text() !== successText) {
        successDiv.text(successText);
        successDiv.addClass('-visible');

        clearInterval(checkInterval);
      } else if (successDiv.text() === successText) {
        clearInterval(checkInterval);
      }
    }

    const checkInterval = setInterval(checkAndReplaceMessage, 500);
  }
}
